import { privateAxios } from 'services/api/privateAxios';
import { adminAPI } from 'services/api/apiUrl';

export const unblockCustomer = id =>
  privateAxios({
    method: 'post',
    baseURL: adminAPI,
    url: `/customer/unblock/${id}`,
  });
